var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"button-back",on:{"click":function($event){return _vm.$emit('click-event')}}},[_c('span',{staticClass:"btn-back"})])}
var staticRenderFns = []

export { render, staticRenderFns }